import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Hello from '@/components/Hello'
import InfoShow from '@/components/InfoShow'
import Song from '@/components/Song'
import Story from '@/components/Story'
import Film from '@/components/Film'
import Timeline from '@/components/Story/Timeline.vue'
import Recipes from '@/components/Story/Recipes'
import Error from '@/components/Err404'
import Interview from '@/components/Film/Interview'
import AboutTeam from '@/components/Film/About'
import Behind from '@/components/Film/Behind'
import Info from '@/components/Song/Info'
import Credits from '@/components/Film/Credits'
// import VueHead from 'vue-head'

// Vue.use(VueHead)
Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/menu',
      name: 'hello',
      component: Hello,
    },
    {
      path: '/song/info/:id',
      name: 'info-song-show',
      component: Info,
      props: ({ params }) => ({ id: String(params.id) }),
      meta: {
        breadcrumb: [{
          url: '/songs',
        }],
      },
    },
    {
      path: '/info/:id',
      name: 'info-story-show',
      component: InfoShow,
      props: ({ params }) => ({ id: String(params.id) }),
      meta: {
        breadcrumb: [{
          url: '/story',
        }],
      },
    },
    {
      path: '/info/:id',
      name: 'info-film-show',
      component: InfoShow,
      props: ({ params }) => ({ id: String(params.id) }),
      meta: {
        breadcrumb: [{
          url: '/film',
        }],
      },
    },
    {
      path: '/info/:id',
      name: 'info-recipe-show',
      component: InfoShow,
      /*eslint-disable*/
      props: ({ params }) => ({ id: String(params.id), titre: String(params.titre), image: String(params.image), description: String(params.description) }),
      /*eslint-enable*/
      meta: {
        breadcrumb: [{
          url: '/story/recipes',
        }],
      },
    },
    {
      path: '/info/:id',
      name: 'info-interview-show',
      component: InfoShow,
      props: ({ params }) => ({ id: String(params.id) }),
      meta: {
        breadcrumb: [{
          url: '/film/interviews',
        }],
      },
    },
    {
      path: '/info/:id',
      name: 'info-behind-show',
      component: InfoShow,
      props: ({ params }) => ({ id: String(params.id) }),
      meta: {
        breadcrumb: [{
          url: '/film',
        }],
      },
    },
    {
      path: '/info/:id',
      name: 'info-about-show',
      component: InfoShow,
      props: ({ params }) => ({ id: String(params.id) }),
      meta: {
        breadcrumb: [{
          url: '/film',
        }],
      },
    },
    {
      path: '/songs',
      name: 'songs',
      component: Song,
      meta: {
        breadcrumb: [{
          url: '/menu',
        }],
      },
    },
    {
      path: '/story',
      name: 'story',
      component: Story,
      meta: {
        breadcrumb: [{
          url: '/menu',
        }],
      },
    },
    {
      path: '/story/chow-mein',
      name: 'chow-mein',
      component: InfoShow,
      props: ({ params }) => ({ id: String('22369447-ad37-4443-bb26-37a9f3817009'), from: true }),
      meta: {
        breadcrumb: [{
          url: '/story',
        }],
      },
    },
    {
      path: '/story/christmas',
      name: 'chris-jew',
      component: InfoShow,
      props: ({ params }) => ({ id: String('b8d8f41b-dd74-4cb8-991f-a2b2da9e9f1c'), from: true }),
      meta: {
        breadcrumb: [{
          url: '/story',
        }],
      },
    },
    {
      path: '/story/timeline',
      name: 'timeline',
      component: Timeline,
      meta: {
        breadcrumb: [{
          url: '/story',
        }],
      },
    },
    {
      path: '/story/recipes',
      name: 'recipes',
      component: Recipes,
      meta: {
        breadcrumb: [{
          url: '/story',
        }],
      },
    },
    {
      path: '/film',
      name: 'film',
      component: Film,
      meta: {
        breadcrumb: [{
          url: '/menu',
        }],
      },
    },
    {
      path: '/film/behind',
      name: 'behind',
      component: Behind,
      meta: {
        breadcrumb: [{
          url: '/film',
        }],
      },
    },
    {
      path: '/film/credits',
      name: 'creduts',
      component: Credits,
      meta: {
        breadcrumb: [{
          url: '/film',
        }],
      },
    },
    {
      path: '/film/about_team',
      name: 'about_team',
      component: AboutTeam,
      meta: {
        breadcrumb: [{
          url: '/film',
        }],
      },
    },
    {
      path: '/film/about',
      name: 'about',
      component: InfoShow,
      props: ({ params }) => ({ id: String('d4b8c2cf-68da-4a63-b263-ec6e9e2781ce'), from: 'film' }),
      meta: {
        breadcrumb: [{
          url: '/film',
        }],
      },
    },
    {
      path: '/film/interviews',
      name: 'interview',
      props: ({ params }) => ({ id: String(params.id) }),
      component: Interview,
      meta: {
        breadcrumb: [{
          url: '/film',
        }],
      },
    },
    {
      path: '*',
      name: 'errors',
      component: Error,
    },
  ],
})

router.afterEach((to, from, next) => {
  if (window._satellite) {
    window._satellite.track('page view')
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js